import styled from 'styled-components';
import { ReactComponent as Alert } from '../../assets/icons/alert.svg';
import { ReactComponent as Back } from '../../assets/icons/back-icon-mobile.svg';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 52px 0 40px 0;

  @media screen and (max-width: 960px) {
    padding: 24px 20px 32px 20px;
    border-radius: 0;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0px 0 10px 0;

  @media screen and (max-width: 960px) {
    border-radius: 0;
    width: 100%;
    justify-content: flex-start;
  }
`;

export const SubWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px 0 20px 0;

  @media screen and (max-width: 960px) {
    width: 100%;
    border-radius: 0;
  }
`;

export const Title = styled.h2`
  font-size: 36px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.primaryDark2};
  margin-bottom: 30px;

  @media screen and (max-width: 960px) {
    font-size: 24px;
    margin: 3px 0px 12px 15px;
  }
`;

export const Subtitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.black};
  margin-bottom: 8px;

  @media screen and (max-width: 960px) {
    margin-bottom: 4px;
    font-size: 20px;
  }
`;

export const Subtitle2 = styled.h2`
  font-size: 16px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.black};
  margin-top: 28px;
  margin-bottom: 10px;

  @media screen and (max-width: 960px) {
    margin-bottom: 16px;
    text-align: center;
  }
`;

export const Content = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 624px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: -4px -4px 8px rgba(255, 255, 255, 0.8),
    4px 4px 6px rgba(36, 36, 36, 0.1);
  border-radius: ${(props) =>
    Number(props.theme.radiusCards) ? `${props.theme.radiusCards}px` : '60px'};

  padding: 28px 40px;
  margin-bottom: 12px;

  &:hover {
    cursor: pointer;
  }

  @media screen and (max-width: 960px) {
    display: -webkit-box;
    border-radius: ${(props) =>
      Number(props.theme.radiusCards)
        ? `${props.theme.radiusCards}px`
        : '10px'};
    width: 100%;
    padding: 20px 16px;
    flex-wrap: wrap;
  }
`;

export const FooterContent = styled.div`
  display: flex;
  align-content: center;
  justify-content: flex-start;
  margin-top: 20px;
  font-weight: 400;
  font-size: 16px;
  color: ${(props) => props.theme.colors.secundary};
  span {
    margin-left: 5px;
    margin-top: 3px;
  }
`;

export const BreadCrumb = styled.div`
  display: block;
  margin-top: 10px;
  font-size: 16px;
  font-weight: 400;
  color: ${(props) => props.theme.colors.primaryDark2};

  @media screen and (max-width: 960px) {
    display: none;
  }

  #bar {
    color: ${(props) => props.theme.colors.secundary};
  }

  #link {
    color: ${(props) => props.theme.colors.secundary};

    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
`;

export const Link = styled.span`
  font-weight: 400;
  color: ${(props) => props.theme.colors.primary};
  text-decoration: underline;

  &:hover {
    cursor: pointer;
  }
`;

export const DetailContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 80%;
  .number {
    color: ${(props) => props.theme.colors.primaryDark2};
    font-weight: 700;
    font-size: 24px;
    margin-bottom: 8px;
  }

  .bank-name {
    font-weight: 700;
    font-size: 16px;
    color: ${(props) => props.theme.colors.gray};
    margin-bottom: 8px;
  }

  .default {
    display: flex;
    font-weight: 400;
    font-size: 14px;
    color: ${(props) => props.theme.colors.gray};
    margin-bottom: 4px;
    line-height: 130%;
    span {
      margin-left: 4px;
    }
  }

  .default2 {
    font-size: 14px;
    color: ${(props) => props.theme.colors.gray};
    margin-bottom: 4px;

    span {
      font-weight: 700;
    }
  }

  .space-right {
    margin-right: 4px;
  }

  .space-left {
    margin-left: 4px;
  }

  .contentText {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0px 15px;
  }

  .spanContent {
    margin-bottom: 8px;
    color: ${(props) => props.theme.colors.gray};
  }

  @media screen and (max-width: 767px) {
    width: 70%;
    .number {
      font-size: 20px;
    }

    .bank-name {
      font-size: 16px;
    }

    .default {
      order: 2;
      font-size: 14px;
    }

    .default2 {
      order: 1;
      font-size: 14px;
    }

    div {
      margin-left: 4px;
    }
  }
`;

export const PlanContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${(props) =>
    Number(props.theme.borderRadius) ? `${props.theme.borderRadius}px` : '5px'};
  background: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.white};
  font-size: 11px;
  padding: 8px;
  font-weight: 400;
  text-align: center;
  width: 56px;
  height: 56px;

  span {
    font-size: 21px;
    font-weight: 700;
  }

  @media screen and (max-width: 960px) {
    order: 3;
    width: 56px;
    height: 56px;
    div {
      margin-top: 8px;
      width: auto;
      height: auto;
      padding: 8px 12px;

      span {
        font-size: 14px;
      }
    }
  }
`;

export const NoContent = styled.div`
  background: ${(props) => props.theme.colors.primaryDark1};
  height: 386px;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 960px) {
    height: auto;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Container2 = styled.div`
  width: 624px;

  @media screen and (max-width: 960px) {
    width: 100%;
  }
`;

export const Message = styled.h2`
  font-weight: 400;
  font-size: 32px;
  margin-top: 20px;
  color: ${(props) => props.theme.colors.white};
`;

export const IconAlert = styled(Alert)`
  width: 25px;
  height: 22px;

  @media screen and (max-width: 960px) {
    width: 40px;
    height: 40px;
  }
`;

export const IconBack = styled(Back)`
  display: none;

  @media screen and (max-width: 960px) {
    display: flex;
    width: 24px;
    height: 24px;
  }
`;

export const IconNext = styled(Back)`
  display: flex;
  -moz-transform: scaleX(-1);
  -o-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
  width: 24px;
  height: 24px;

  path[id='CHEVRON-LEFT'] {
    fill: ${(props) => props.theme.colors.black};
  }
`;

export const Line = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
  width: 50%;

  @media screen and (max-width: 960px) {
    margin-bottom: 0px;
  }
`;

export const DivIconNext = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  width: 10%;
  min-width: 24px;
  min-height: 24px;
`;
